import { useTranslation as useI18nTranslation } from "react-i18next";

/**
 * Typisierter Wrapper für react-i18next's useTranslation Hook.
 * Nutzt immer die echte i18n-Instanz, damit Übersetzungsschlüssel korrekt
 * aus den Locale-Dateien aufgelöst werden.
 *
 * @param namespace - Optionaler Namespace (z.B. 'landing', 'dashboard')
 * @returns Translation-Funktion und i18n-Instanz
 */
export function useTranslation(namespace?: string) {
  return useI18nTranslation(namespace);
}
